import { AxiosResponse } from 'axios';
import { DocumentCivilUnionFormVM } from 'civil-status/view-models/document-birth-form';
import { DateTime } from 'luxon';
import { DocumentCivilUnionCM } from 'shell/models/document-civil-union';
import { HttpResponse } from 'shell/models/http-response';

export const transformDocumentCivilUnion = (
  response: AxiosResponse<HttpResponse<DocumentCivilUnionCM>>
): DocumentCivilUnionFormVM => {
  const payloadResponse = response.data?.payload;
  const item: DocumentCivilUnionFormVM = {
    indicatorUpdate:
      payloadResponse?.datiAttoUnioneCivile?.flagAggiornato === '0' ||
      !payloadResponse?.datiAttoUnioneCivile?.flagAggiornato
        ? 'È necessario effettuare la convalida dei dati.'
        : '',
    matricola: payloadResponse?.datiAttoUnioneCivile?.matricolaConiuge1?.toString() || '',
    surnamePostUnionDeclarant2:
      payloadResponse?.datiAttoUnioneCivile?.cognomeDopoMatrimonioConiuge2 || '',
    citizenshipDeclarant1: payloadResponse?.datiAttoUnioneCivile?.cittadinanzaConiuge1 || '',
    citizenshipDeclarant2: payloadResponse?.datiAttoUnioneCivile?.cittadinanzaConiuge2 || '',
    residenceMunicipalityDeclarant1:
      payloadResponse?.datiAttoUnioneCivile?.comuneResidenzaConiuge1 || '',
    residenceMunicipalityDeclarant2:
      payloadResponse?.datiAttoUnioneCivile?.comuneResidenzaConiuge2 || '',
    surnamePostUnionDeclarant1:
      payloadResponse?.datiAttoUnioneCivile?.cognomeDopoMatrimonioConiuge1 || '',
    civilUnionDate: payloadResponse?.datiAttoUnioneCivile?.dataMatrimonio
      ? DateTime.fromISO(payloadResponse?.datiAttoUnioneCivile?.dataMatrimonio)
      : null,
    civilUnionMunicipality: payloadResponse?.datiAttoUnioneCivile?.comuneMatrimonio || '',
    surname: payloadResponse?.datiAttoUnioneCivile?.cognomeConiuge1 || '',
    surname2: payloadResponse?.datiAttoUnioneCivile?.cognomeConiuge2 || '',
    name2: payloadResponse?.datiAttoUnioneCivile?.nomeConiuge2 || '',
    gender2: payloadResponse?.datiAttoUnioneCivile?.sessoConiuge2 || '',
    municipalityBirth2: payloadResponse?.datiAttoUnioneCivile?.comuneNascitaConiuge2 || '',
    time2: payloadResponse?.datiAttoUnioneCivile?.oraNascitaConiuge2
      ? DateTime.fromISO(payloadResponse?.datiAttoUnioneCivile?.oraNascitaConiuge2)
      : null,
    birthday2: payloadResponse?.datiAttoUnioneCivile?.dataNascitaConiuge2
      ? DateTime.fromISO(payloadResponse?.datiAttoUnioneCivile?.dataNascitaConiuge2)
      : null,
    matricola2: payloadResponse?.datiAttoUnioneCivile?.matricolaConiuge2?.toString() || '',
    name: payloadResponse?.datiAttoUnioneCivile?.nomeConiuge1 || '',
    gender: payloadResponse?.datiAttoUnioneCivile?.sessoConiuge1 || '',
    municipalityBirth: payloadResponse?.datiAttoUnioneCivile?.comuneNascitaConiuge1 || '',
    time: payloadResponse?.datiAttoUnioneCivile?.oraNascitaConiuge1
      ? DateTime.fromISO(payloadResponse?.datiAttoUnioneCivile?.oraNascitaConiuge1)
      : null,
    birthday: payloadResponse?.datiAttoUnioneCivile?.dataNascitaConiuge1
      ? DateTime.fromISO(payloadResponse?.datiAttoUnioneCivile?.dataNascitaConiuge1)
      : null,
    year: payloadResponse?.datiAttoUnioneCivile?.anno || '',
    registerNumber: payloadResponse?.datiAttoUnioneCivile?.numeroRegistro || '',
    documentNumber: payloadResponse?.datiAttoUnioneCivile?.numeroAtto?.toString() || '',
    portion: payloadResponse?.datiAttoUnioneCivile?.parte || '',
    serie: payloadResponse?.datiAttoUnioneCivile?.serie1?.trim() || '',
    serie2: payloadResponse?.datiAttoUnioneCivile?.serie2?.trim() || '',
    uploadFile:
      payloadResponse?.attoUnioneCivileCM?.attoByteArray &&
      payloadResponse?.attoUnioneCivileCM?.atto
        ? {
            raw:
              payloadResponse?.attoUnioneCivileCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
            rawTiff: `data:image/png;base64,${payloadResponse?.attoUnioneCivileCM?.attoByteArray}`,
            file: new File(
              payloadResponse?.attoUnioneCivileCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
              payloadResponse?.attoUnioneCivileCM?.nomeFile
            ),
          }
        : undefined,
    annotationInternationalList:
      payloadResponse?.annotazioniAttoUnioneCivileInt?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
    annotationNationalList:
      payloadResponse?.annotazioniAttoUnioneCivileNaz?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
  };
  return item;
};

const transformConiuge1Request = (values: DocumentCivilUnionFormVM) =>
  ({
    key: {
      numeroAtto: values.documentNumber || undefined,
      numeroRegistro: values.registerNumber || undefined,
      parte: values.portion || undefined,
      serie1: values.serie || undefined,
      serie2: values.serie2 || undefined,
      anno: values.year || undefined,
    },
    dataMatrimonio: values.civilUnionDate || undefined,
    comuneMatrimonio: values.civilUnionMunicipality || undefined,
    matricola: values.matricola || undefined,
    cognome: values.surname || undefined,
    nome: values.name || undefined,
    dataNascita: values.birthday ? values.birthday.toFormat('yyyy-MM-dd') : undefined,
    anni: values.yearsDeclarant1 || undefined,
    sesso: values.gender || undefined,
    comuneNascita: values.municipalityBirth || undefined,
    comuneResidenza: values.residenceMunicipalityDeclarant1 || undefined,
    cittadinanza: values.citizenshipDeclarant1 || undefined,
    // cittadinanza: dato non in maschera
    // statoCivile: values.martitalStatusDeclarant1 || undefined,
    annoNascita: values.yearDateDeclarant1 || undefined,
    cognomeDopoMatrimonio: values.surnamePostUnionDeclarant1 || undefined,
  } as const);

const transformConiuge2Request = (values: DocumentCivilUnionFormVM) =>
  ({
    key: {
      numeroAtto: values.documentNumber || undefined,
      numeroRegistro: values.registerNumber || undefined,
      parte: values.portion || undefined,
      serie1: values.serie || undefined,
      serie2: values.serie2 || undefined,
      anno: values.year || undefined,
    },
    dataMatrimonio: values.civilUnionDate || undefined,
    comuneMatrimonio: values.civilUnionMunicipality || undefined,
    matricola: values.matricola2 || undefined,
    cognome: values.surname2 || undefined,
    nome: values.name2 || undefined,
    dataNascita: values.birthday2 ? values.birthday2.toFormat('yyyy-MM-dd') : undefined,
    anni: values.yearsDeclarant2 || undefined,
    sesso: values.gender2 || undefined,
    comuneNascita: values.municipalityBirth2 || undefined,
    comuneResidenza: values.residenceMunicipalityDeclarant2 || undefined,
    cittadinanza: values.citizenshipDeclarant2 || undefined,
    // cittadinanza: dato non in maschera
    // statoCivile: values.martitalStatusDeclarant2 || undefined,
    annoNascita: values.yearDateDeclarant2 || undefined,
    cognomeDopoMatrimonio: values.surnamePostUnionDeclarant2 || undefined,
  } as const);

export const transformDocumentCivilUnionRequest = (values: DocumentCivilUnionFormVM) =>
  ({
    coniuge1: transformConiuge1Request(values),
    coniuge2: transformConiuge2Request(values),
  } as const);
